import React, {CSSProperties} from "react";
import {TDAForm} from "@dreebit-registry/vsm-microservice-components";

interface Props {
    attributes: any[]
    onChange?: (index: any, value: unknown) => void
    onReset?: () => void
    onSearch?: (values: { query: string, fields: string[] }) => void
    initialValues?: { [key: string]: any }
    searchParams?: { query: string, fields: string[] }
    formStyle?: CSSProperties
    onValuesChange?: (values: { [p: string]: any }) => void,
}

const ListFilter = ({attributes, onChange, onReset, onSearch, initialValues, searchParams, formStyle, onValuesChange}: Props) => {

    return (
        <TDAForm
            attributes={attributes}
            layout={'row'}
            useFilterLabel={true}
            onChange={onChange}
            onValuesChange={onValuesChange}
            onReset={onReset}
            onSearch={onSearch}
            initialFormValues={initialValues}
            searchParams={searchParams ?? {query: '', fields: []}}
            formStyle={formStyle}
        />
    );
};

export default ListFilter;
